module.exports = __webpack_public_path__ + "img/lifted.a7ce485e.png";